import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class PageGroupController extends AuthenticatedController {
  static getAll(chatbotId: number) {
    return super.get(APIRoutes.PAGE_GROUPS, { bot_id: chatbotId });
  }

  static post(entity) {
    return super.post(APIRoutes.PAGE_GROUPS, entity);
  }

  static put(entity) {
    return super.put(`${APIRoutes.PAGE_GROUPS}/${entity.id}`, entity);
  }

  static patch(entities) {
    return super.patch(`${APIRoutes.PAGE_GROUPS}/batch_update`, entities);
  }

  static delete(pageGroupId) {
    return super.delete(`${APIRoutes.PAGE_GROUPS}/${pageGroupId}`);
  }
}
